import React, { useState, useEffect, useContext } from 'react';
import { ArrowDownOnSquareIcon, ClockIcon, MoonIcon, SunIcon } from '@heroicons/react/20/solid';
// import ClockInData from './clockindata';
// import Modal from './modal';
import { useNavigate } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { set } from 'lodash';
import LoadingComponent from './loading';
import { AuthContext } from "../AuthContext";

export default function StaffActions() {
  const [staffList, setStaffList] = useState([]);
  const [clock, setClock] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [error, setError] = useState(null);
  const [staff, setStaff] = useState([]);

  const user = useContext(AuthContext);

  // current user

  const currentId = user?.id;


  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  const fetchStaff = async () => {
    try {
      // Fetch staff data
      const staffResponse = await fetch('https://api.insightos.co.uk/api/staff', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

      });

      const staffData = await staffResponse.json();

      if (!staffResponse.ok) {
        throw new Error(staffData.message || 'Failed to fetch staff data.');
      }

      const staff = staffData.data;

      // Fetch clock-in data
      const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

      });

      const clockInData = await clockInResponse.json();

      if (!clockInResponse.ok) {
        throw new Error(clockInData.message || 'Failed to fetch clock-in data.');
      }

      const clockInDataAll = clockInData.data;

      // Debug logging
      console.log('ClockIn Data:', clockInDataAll);

      // Process and merge data
      const staffWithClockInStatus = staff.map((staffMember) => {
        const id = staffMember.id;
        const today = format(new Date(), 'yyyy-MM-dd'); // Format the date to 'YYYY-MM-DD'

        const clockInDataForUser = clockInDataAll.find(
          (c) => {
            // Convert ISO date to comparable format
            const clockInDate = parseISO(c.Date);
            const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
            
            return c.StaffId === id && clockInDateFormatted === today;
          }
        );

        // Debug logging
        console.log(`Staff Member: ${staffMember.Name}`);
        console.log(`ClockInDataForUser:`, clockInDataForUser);

        return {
          ...staffMember,
          isClockedIn: clockInDataForUser ? clockInDataForUser.ClockedIn === 1 && clockInDataForUser.ClockedOut === 0 : false,
          isOnBreak: clockInDataForUser ? clockInDataForUser.Break === 1 : false,
          clockInTime: clockInDataForUser ? clockInDataForUser.ClockIn : null, // Add ClockIn field here
        };
      });

      // Debug logging
      console.log('Staff with Clock-In Status:', staffWithClockInStatus);

      setStaffList(staffWithClockInStatus);
    } catch (error) {
      console.error('Error fetching staff data:', error);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, [reload]);


      const fetchClockIns = async () => {
        try {
          const clockIns = await fetch('https://api.insightos.co.uk/api/clockins', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json',
             },
              credentials : 'include',
          });
  
          if (!clockIns.ok) throw new Error('Failed to fetch clock ins');
          const data = await clockIns.json();
          setStaff(data.data);
        } catch (error) {
          console.error('Failed to fetch clock ins:', error);
        }
      };



      useEffect(() => {
  
      fetchClockIns(); // Initial fetch
      
    }, []);

  

  console.log('Staff List:', staffList);


  const handleClockInOut = async (staff) => {
  setIsLoading(true);
  const id = staff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (window.electron && window.electron.GeoAPI) {
          window.electron.GeoAPI.getLocation()
            .then((geoTag) => resolve(geoTag))
            .catch(() => resolve('Unknown'));
        } else if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.find((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered && clockInDataFiltered.ClockedIn === 1 && clockInDataFiltered.ClockedOut === 0) {
      const clockInTime = new Date(`${dateOnly}T${clockInDataFiltered.ClockIn}`);
      const clockOutTime = now;
      const shiftLengthInMinutes = (clockOutTime - clockInTime) / 60000;
      const totalPay = shiftLengthInMinutes * (staff.HourlyRate / 60);

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/addput/${clockInDataFiltered.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockOut: timeOnly,
          ClockedOut: 1,
          ClockedIn: 0,
          HoursWorked: parseFloat(shiftLengthInMinutes) / 60,
          TotalPay: parseFloat(totalPay),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to update clock-out');

      console.log(`${staff.Name} clocked out with GeoTag: ${geoTag}`);
      success = true;
    } else {
      const todaysshiftResponse = await fetch('https://api.insightos.co.uk/api/todaysshift', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!todaysshiftResponse.ok) {
        const err = await todaysshiftResponse.json().catch(() => ({}));
        throw new Error(err.message || 'Failed to fetch todayshift data.');
      }

      const todaysshiftData = await todaysshiftResponse.json();
      const todaysshift = todaysshiftData.data;

      const shift = todaysshift.find((shift) => shift.StaffId === id);
      if (!shift) throw new Error('No shift found for the staff member.');

      const shiftStartTime = shift.StartTime;
      const late = shiftStartTime < timeOnly ? 1 : 0;

      const postRes = await fetch('https://api.insightos.co.uk/api/clockin/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockIn: timeOnly,
          ClockedIn: 1,
          ClockedOut: 0,
          HourlyRate: staff.HourlyRate,
          StaffId: staff.id,
          Date: dateOnly,
          Department: staff.Role,
          StaffName: staff.Name,
          Late: late,
          GeoTag: geoTag,
        }),
      });

      const postJson = await postRes.json().catch(() => ({}));
      if (!postRes.ok) throw new Error(postJson.message || 'Failed to create clock-in');

      console.log(`${staff.Name} clocked in with GeoTag: ${geoTag}`);
      success = true;
    }
  } catch (error) {
    console.error('Error handling clock in/out:', error);
    setError(error.message || 'No Shift Found For This Staff Member, Cannot Clock In');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};



  

const handleBreakStartEnd = async (staff) => {
  setIsLoading(true);
  const id = staff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.filter((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered.length > 0 && clockInDataFiltered[0].Break === 1) {
      const breakStart = new Date(`${dateOnly}T${clockInDataFiltered[0].BreakStart}`);
      const breakEnd = now;
      const breakLength = (breakEnd - breakStart) / 60000;

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakend/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakEnd: timeOnly,
          Break: 0,
          StaffBreak: parseFloat(breakLength),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to end break');

      console.log(`${staff.Name} ended break with GeoTag: ${geoTag}`);
      success = true;
    } else if (clockInDataFiltered.length > 0) {
      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakstart/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakStart: timeOnly,
          Break: 1,
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to start break');

      console.log(`${staff.Name} started break with GeoTag: ${geoTag}`);
      success = true;
    } else {
      console.log('No clock-in record found for today.');
      setError('No clock-in record found for today.');
    }
  } catch (error) {
    console.error('Error handling break start/end:', error);
    setError(error.message || 'Error handling break start/end');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};

// HANDLERS FOR ACTING ON OTHER USERS (do not call the same endpoints as current user actions)
const handleClockInOutOther = async (otherStaff) => {
  setIsLoading(true);
  const id = otherStaff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (window.electron && window.electron.GeoAPI) {
          window.electron.GeoAPI.getLocation()
            .then((geoTag) => resolve(geoTag))
            .catch(() => resolve('Unknown'));
        } else if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.find((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered && clockInDataFiltered.ClockedIn === 1 && clockInDataFiltered.ClockedOut === 0) {
      const clockInTime = new Date(`${dateOnly}T${clockInDataFiltered.ClockIn}`);
      const clockOutTime = now;
      const shiftLengthInMinutes = (clockOutTime - clockInTime) / 60000;
      const totalPay = shiftLengthInMinutes * (otherStaff.HourlyRate / 60);

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/staffend/${clockInDataFiltered.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockOut: timeOnly,
          ClockedOut: 1,
          ClockedIn: 0,
          HoursWorked: parseFloat(shiftLengthInMinutes) / 60,
          TotalPay: parseFloat(totalPay),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to clock out other user');

      console.log(`${otherStaff.Name} clocked out with GeoTag: ${geoTag}`);
      success = true;
    } else {
      const todaysshiftResponse = await fetch('https://api.insightos.co.uk/api/todaysshift', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (!todaysshiftResponse.ok) {
        const err = await todaysshiftResponse.json().catch(() => ({}));
        throw new Error(err.message || 'Failed to fetch todayshift data.');
      }

      const todaysshiftData = await todaysshiftResponse.json();
      const todaysshift = todaysshiftData.data;
      const shift = todaysshift.find((shift) => shift.StaffId === id);

      if (!shift) throw new Error('No shift found for the staff member.');

      const shiftStartTime = shift.StartTime;
      const late = shiftStartTime < timeOnly ? 1 : 0;

      const postRes = await fetch('https://api.insightos.co.uk/api/clockin/staffstart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ClockIn: timeOnly,
          ClockedIn: 1,
          ClockedOut: 0,
          HourlyRate: otherStaff.HourlyRate,
          StaffId: otherStaff.id,
          Date: dateOnly,
          Department: otherStaff.Role,
          StaffName: otherStaff.Name,
          Late: late,
          GeoTag: geoTag,
        }),
      });

      const postJson = await postRes.json().catch(() => ({}));
      if (!postRes.ok) throw new Error(postJson.message || 'Failed to clock in other user');

      console.log(`${otherStaff.Name} clocked in with GeoTag: ${geoTag}`);
      success = true;
    }
  } catch (error) {
    console.error('Error handling clock in/out for other user:', error);
    setError(error.message || 'No Shift Found For This Staff Member, Cannot Clock In');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};

const handleBreakStartEndOther = async (otherStaff) => {
  setIsLoading(true);
  const id = otherStaff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');
  let success = false;

  try {
    const getGeoTag = () =>
      new Promise((resolve) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve(`${latitude},${longitude}`);
            },
            () => resolve('Unknown')
          );
        } else {
          resolve('Unknown');
        }
      });

    const geoTag = await getGeoTag();

    const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (!clockInResponse.ok) {
      const err = await clockInResponse.json().catch(() => ({}));
      throw new Error(err.message || 'Failed to fetch clock-in records');
    }

    const clockInData = await clockInResponse.json();
    const clockInDataAll = clockInData.data;

    const clockInDataFiltered = clockInDataAll.filter((c) => {
      const clockInDate = parseISO(c.Date);
      const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
      return c.StaffId === id && clockInDateFormatted === dateOnly;
    });

    if (clockInDataFiltered.length > 0 && clockInDataFiltered[0].Break === 1) {
      const breakStart = new Date(`${dateOnly}T${clockInDataFiltered[0].BreakStart}`);
      const breakEnd = now;
      const breakLength = (breakEnd - breakStart) / 60000;

      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakend/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakEnd: timeOnly,
          Break: 0,
          StaffBreak: parseFloat(breakLength),
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to end break for other user');

      console.log(`${otherStaff.Name} ended break with GeoTag: ${geoTag}`);
      success = true;
    } else if (clockInDataFiltered.length > 0) {
      const putRes = await fetch(`https://api.insightos.co.uk/api/clockin/breakstart/${clockInDataFiltered[0].id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          BreakStart: timeOnly,
          Break: 1,
          GeoTag: geoTag,
        }),
      });

      const putJson = await putRes.json().catch(() => ({}));
      if (!putRes.ok) throw new Error(putJson.message || 'Failed to start break for other user');

      console.log(`${otherStaff.Name} started break with GeoTag: ${geoTag}`);
      success = true;
    } else {
      console.log('No clock-in record found for today.');
      setError('No clock-in record found for today.');
    }
  } catch (error) {
    console.error('Error handling break start/end for other user:', error);
    setError(error.message || 'Error handling break for other user');
  } finally {
    setIsLoading(false);
    if (success) setReload((prev) => !prev);
  }
};

const handleClockOutAll = async () => {
  setIsLoading(true); // Start loading
  try {
      const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockoutall', {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json',
          },
          credentials : 'include',

      });
      const clockInData = await clockInResponse.json();
      if (!clockInResponse.ok) {
          throw new Error(clockInData.message || 'Failed to clock out all staff.');
      }
  console.log('All staff clocked out successfully.');
  // Toggle reload to refresh main list and re-fetch clock ins
  setReload(prev => !prev);
  fetchClockIns(); 
  } catch (error) {
      console.error('Error clocking out all staff:', error);
      setError('Failed to clock out all staff.');
  }
  setIsLoading(false);
};




  // if (clock === true) {
  //   return <ClockInData />;
  // }

  const [query, setQuery] = useState('');

  // Find the current user entry in staffList (if available)
  const currentUser = staffList.find((s) => s.id === currentId) || null;

  // Early return when loading
  if (isLoading) {
    return (
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center py-12">
          <LoadingComponent />
        </div>
      </div>
    );
  }

  // Minimal UI: only show the current user's break button (no table, no names)
  return (
    <div className="px-4 sm:px-6 lg:px-8 mt-10 mb-10">
      {error && <div className="mb-4 text-sm text-red-400">{error}</div>}

      <div className="flex items-center justify-center">
        {currentUser ? (
          <button
            onClick={() => handleBreakStartEnd(currentUser)}
            className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium focus:outline-none transition transform duration-150 ease-in-out ${currentUser.isOnBreak ? 'bg-green-600 hover:bg-green-700 text-white hover:shadow-md hover:scale-105' : 'bg-orange-500 hover:bg-orange-600 text-white hover:shadow-md hover:scale-105'}`}
          >
            {currentUser.isOnBreak ? <SunIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4" />}
            {currentUser.isOnBreak ? 'End Break' : 'Start Break'}
          </button>
        ) : (
          <div className="text-center text-sm text-gray-600">No current user found or not clocked in.</div>
        )}
      </div>
    </div>
  );
}

